import { DateTime } from 'luxon';
import { request } from './request';
import { getUserId, getMerchantId } from './user.service';


export async function filterDashboard(
  fromDate,
  toDate,
  abortController = null,
  handleErrorResponse = null,
  showToastOnError = true,
  suppressTealiumEvent = false,
) {
  const formattedFrom = DateTime.fromJSDate(fromDate).toFormat('yyyy-MM-dd HH:mm');
  const formattedTo = DateTime.fromJSDate(toDate).toFormat('yyyy-MM-dd HH:mm');

  const userId = getUserId();
  const merchantId = getMerchantId();
  const res = await request(
    `dated-transaction?userReference=${userId}&fromDate=${formattedFrom}&toDate=${formattedTo}&merchantId=${merchantId}`,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController?.signal || null,
      },
    },
    null,
    null,
    showToastOnError,
    suppressTealiumEvent,
  );

  const isAborted = !!abortController && abortController.signal.aborted;
  if (res?.status === 200) {
    return res.result;
  } else if (handleErrorResponse && !isAborted) {
    handleErrorResponse(
      'error response from the dated-transaction GET endpoint',
      true,
      suppressTealiumEvent,
      res,
    );
  }
}

export async function staticDashboard(
  abortController,
  handleErrorResponse = null,
  showToastOnError = true,
  suppressTealiumEvent = false,
) {
  const userId = getUserId();
  const merchantId = getMerchantId();
  const res = await request(
    `recent-transaction?userReference=${userId}&merchantId=${merchantId}&channelId=WEB&channelName=Vodacom`,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController?.signal || null,
      },
    },
    null,
    null,
    showToastOnError,
    suppressTealiumEvent,
  );

  const isAborted = !!abortController && abortController.signal.aborted;
  if (res?.status === 200) {
    return res.result;
  } else if (handleErrorResponse && !isAborted) {
    handleErrorResponse(
      'error response from the recent-transaction GET endpoint',
      true,
      suppressTealiumEvent,
      res,
    );
  }
}
